export const calculateDiscount = (partialValue: number, totalValue: number) => {
  return Math.round(((totalValue - partialValue) / totalValue) * 100);
};

export const applyDiscount = (value: number, discount: number) => {
  return value - (value * discount) / 100;
};
